
const formatTime = (time) =>
{
  if (isNaN(time)) return "NaN";

  /**
   * How come there are so many bad examples of how to do this online
   * when it's literally just 3 lines of code
   */
  
  let seconds = Math.floor(time % 60);
  let minutes = Math.floor(((time / 60) % 60));
  return `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
}

export default formatTime;